export default "__VITE_ASSET__DfZi7qO4__"